<template>
    <div class="w-full h-full relative">
        <div class="flex items-end">
            <custom-input
                v-if="isOpenInput"
                v-model="keyword"
                class="w-full min-w-0"
                label="Nuevo tag"
                :disabled="!enabled || creating"
                @enter="confirmAdd"
            />
            <custom-multiple-select
                v-else
                :value="selectedValues"
                mode="search"
                :label="label"
                class="w-full min-w-0"
                :options="tagOptions"
                :disabled="!enabled"
                @change="onSelectionChange"
            />

            <app-button
                v-if="enabled && allowCreate"
                icon
                border
                :loading="creating"
                @click="toggleAdd"
            >
                {{ isOpenInput ? "✔️" : "➕" }}
            </app-button>
        </div>
    </div>
</template>

<script>
import AppButton from "@/components/utils/AppButton.vue";
import CustomInput from "@/components/utils/CustomInput.vue";
import CustomMultipleSelect from "@/components/utils/CustomMultipleSelect.vue";

export default {
    name: "TagsSelector",
    components: { AppButton, CustomInput, CustomMultipleSelect },
    model: {
        prop: "itemsCurrent",
        event: "change"
    },
    props: {
        label: {
            type: String,
            default: () => "",
            required: false
        },
        tags: {
            type: Array,
            default: () => [],
            required: true
        },
        itemsCurrent: {
            type: Array,
            default: () => [],
            required: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        },
        allowCreate: {
            default: () => false,
            type: Boolean,
            required: false
        },
        creating: {
            default: () => false,
            type: Boolean,
            required: false
        }
    },
    emits: ["change", "create"],
    data: () => ({
        selectedValues: [],
        isOpenInput: false,
        keyword: ""
    }),
    computed: {
        tagOptions() {
            return this.tags.map((tag) => ({
                label: tag.name,
                value: tag.value
            }));
        }
    },
    watch: {
        itemsCurrent(value) {
            this.selectedValues = [...value];
        },
        creating(value) {
            if (!value) this.keyword = "";
        }
    },
    mounted() {
        this.selectedValues = [...this.itemsCurrent];
    },
    methods: {
        onSelectionChange(value) {
            this.selectedValues = value;
            this.$emit("change", value);
        },
        toggleAdd() {
            if (this.isOpenInput) {
                this.confirmAdd();
            } else {
                this.isOpenInput = true;
            }
        },
        confirmAdd() {
            const name = this.keyword.trim();
            this.isOpenInput = false;
            if (!name) return;
            this.$emit("create", name);
            this.keyword = "";
        }
    }
};
</script>
